module.exports = __webpack_public_path__ + "img/list-blue.a7576c70.svg";